import { requiredNamedObjectSchema } from './named-object.js';
import { frequencySchema } from './frequency.js';
import { IllegalArgumentError } from 'faro-common-model';
import { z } from 'zod';
import { uuidish } from '../utils/uuidish.js';
import { nullishToUndefined } from '../utils/nullishToUndefined.js';
export const interventionInstructionsDoseInstructionsMaxLength = 250;
/**
 * The type of intervention instruction
 */
export var InterventionInstructionsType;
(function (InterventionInstructionsType) {
    InterventionInstructionsType["frequency"] = "frequency";
    InterventionInstructionsType["custom"] = "custom";
})(InterventionInstructionsType || (InterventionInstructionsType = {}));
export const interventionInstructionsSchema = z.object({
    interventionId: uuidish,
    type: z.enum(InterventionInstructionsType),
    doseAmount: z.number().min(0).nullish().transform(nullishToUndefined).optional(),
    doseRelativeUnit: requiredNamedObjectSchema.nullish().transform(nullishToUndefined).optional(),
    frequency: frequencySchema.nullish().transform(nullishToUndefined).optional(),
    doseInstructions: z
        .string()
        .max(interventionInstructionsDoseInstructionsMaxLength)
        .nullish()
        .transform(nullishToUndefined)
        .optional(),
});
export function toInterventionInstructions(interventionInstructions) {
    const result = interventionInstructionsSchema.safeParse(interventionInstructions);
    if (!result.success) {
        throw new IllegalArgumentError(`Invalid InterventionInstructions object. ${result.error.message}`);
    }
    return result.data;
}
//# sourceMappingURL=intervention-instructions.js.map